import { Injectable } from '@angular/core';
import { Subject, Subscription, interval } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShowcaseSyncService {
  private subject = new Subject<void>();
  switch$ = this.subject.asObservable();

  private intervalSub?: Subscription;
  private started = false;

  start(intervalMs = 5000, immediateTick = false): void {
    if (this.started) return;

    this.started = true;

    if (immediateTick) {
      this.subject.next();
    }

    this.intervalSub = interval(intervalMs).subscribe(() => {
      this.subject.next();
    });
  }

  reset(): void {
    this.intervalSub?.unsubscribe();
    this.intervalSub = undefined;
    this.started = false;
  }
}
